import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';

import React from 'react';
import { Router, Link, browserHistory } from 'react-router';

import MgfForm from '../common/mgfForm';
import { PlaceSchema, Places } from '../../collections/flights/places';

import {
  BPanel,
  Table,
  Button,
  Form,
  FormGroup,
  Col,
  Checkbox,
  ControlLabel,
  FormControl,
  Breadcrumb,
  BreadcrumbItem
} from '@sketchpixy/rubix';

export default class PlaceAddPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}	

	handleSubmit(doc) {
		this.context.router.push('/places');
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/places">Lieux d'envols</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Ajouter un lieu d'envol
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Ajouter un lieu d'envol">
					<MgfForm schema={PlaceSchema} collection={Places} onSubmit={this.handleSubmit.bind(this)} />
				</BPanel>
			</div>
		);
	}
}

PlaceAddPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/places/PlaceAdd.page.js
 **/